import React from 'react';
import classes from './styles.module.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HOME_PAGE, PROFILE_PAGE } from '../../constants/route.const';
import { Image, Box, Heading, Flex, Button } from '@chakra-ui/react';
import SKButton from '../UI/SKButton/index';
import logo from '../../assets/logo/pro-logo.svg';
import BackSVG from '../../assets/icons/back.svg';
import { StorageService } from 'service/Storage';
function Header() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isFromApp = StorageService.getSessionFrom() === 'app';
  const isHome = pathname === '/';
  const showBg =
    pathname === '/profile' || pathname === '/verify' || pathname === '/';

  return (
    <Flex as="header" justifyContent={'space-between'}>
      {!isFromApp && (
        <Link to={HOME_PAGE}>
          <Box className={classes.left}>
            <Flex alignItems={'center'}>
              <Image
                className={classes.logo}
                src={logo}
                h={['35px', '45px']}
                w={['40px', '50px']}
              />
              <Heading
                fontSize={['21px', '28px']}
                display={['none', null, 'block']}
                color={['#BE6F4F']}
                fontWeight={'semibold'}
              >
                Chillar Pro
              </Heading>
            </Flex>
          </Box>
        </Link>
      )}
      {isFromApp && pathname === PROFILE_PAGE && (
        <>
          {/* Back Button */}
          <Button
            // onClick , close the webview from android kotlin app
            onClick={() => {
              // create a fake get request to close the webview
              fetch('/close');
            }}
          >
            <Image src={BackSVG} />
          </Button>
        </>
      )}

      {isHome && (
        <Link to={'verify'}>
          <SKButton
            w={['130px', '200px']}
            h={['45px', '50px']}
            mr={'23px'}
            color="white"
            borderRadius="13px"
            fontWeight="semibold"
          >
            Wallet
          </SKButton>
        </Link>
      )}
    </Flex>
  );
}
export default Header;
